import { createApi } from 'effector';
import produce, { type Draft } from 'immer';
import type { GeneralID, LibUploadingMap } from '@types';
import domain from '../domain';
import libReset from '../actions/libReset';

type UDraft = Draft<LibUploadingMap>;

const createUploadingStore = () => {
  const store = domain.store<LibUploadingMap>(new Map()).reset(libReset);
  const api = createApi(store, {
    add: produce((draft: UDraft, payload: { id: GeneralID; name: string }) => {
      draft.set(payload.id, { ...payload, libId: 0, progress: '等待中' });
    }),
    addRunningTask: produce(
      (
        draft: UDraft,
        payload: { libId: number; name: string; progress: string }
      ) => {
        const isExist = [...draft.values()].some(
          (x) => x.libId === payload.libId
        );
        if (isExist) return;
        draft.set(payload.libId, { ...payload, id: payload.libId });
      }
    ),
    remove: produce((draft: UDraft, id: GeneralID) => {
      draft.delete(id);
    }),
    progress: produce(
      (draft: UDraft, payload: { id: GeneralID; progress: string }) => {
        const item = draft.get(payload.id);
        if (!item) return;
        item.progress = payload.progress;
      }
    ),
    libId: produce(
      (draft: UDraft, payload: { id: GeneralID; libId: number }) => {
        const item = draft.get(payload.id);
        if (!item) return;
        item.libId = payload.libId;
      }
    ),
    removeByLibId: produce((draft: UDraft, libId: number) => {
      draft.forEach((v, k) => {
        if (v.libId === libId) draft.delete(k);
      });
    }),
  });
  return { store, api };
};

export const $libUploadingPano = createUploadingStore();
export const $libUploadingPVideo = createUploadingStore();
export const $libUploadingMatrix = createUploadingStore();
